module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-loader-autoprefix-287.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-loader-autoprefix.md
// module id = 732
// module chunks = 214